import { Link } from 'react-router-dom';
import type { HomepageConfig } from '@cng/shared';
import { SmartImage } from '@/components/common/SmartImage';

export function CuratedServices({ config }: { config: HomepageConfig['curatedServices'] }) {
  const cards = (config?.cards ?? []).filter((c) => c.enabled).sort((a, b) => a.order - b.order);
  if (!config?.enabled || cards.length === 0) return null;

  return (
    <section className="experience-section" aria-labelledby="curated-services-title">
      <div className="exp-header">
        <h2 className="exp-title" id="curated-services-title">
          {config.title}
          {config.titleAccent ? <> <span>{config.titleAccent}</span></> : null}
        </h2>
      </div>

      <div className="exp-grid">
        {cards.map((card) => {
          const internal = card.href.startsWith('/') && !card.href.startsWith('//');
          const inner = (
            <>
              <SmartImage
                media={card.image}
                alt={card.alt || card.image?.alt || card.title}
                sizes="(max-width: 900px) 100vw, 570px"
              />
              <div className="exp-overlay">
                <div className="exp-content-box">
                  <h3 className="exp-card-title">{card.title}</h3>
                  {card.subtitle ? <div className="exp-sub">{card.subtitle}</div> : null}
                </div>
                <div className="icon-circle" aria-hidden="true">→</div>
              </div>
            </>
          );

          return internal ? (
            <Link className="exp-card" to={card.href} key={card.href}>{inner}</Link>
          ) : (
            <a className="exp-card" href={card.href} key={card.href}>{inner}</a>
          );
        })}
      </div>
    </section>
  );
}
